import TextStyling from './TextStyling';

const NotificationBanner = ({ bannerId = '', bannerType = '', notificationText = [] } = {}) => ({
  bannerId: String(bannerId),
  bannerType: String(bannerType),
  notificationText: notificationText.map((item) => TextStyling(item)),
});

export default NotificationBanner;

export type NotificationBannerType = ReturnType<typeof NotificationBanner>;
